import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "lenis/dist/lenis.css";
import { initAnalytics } from './utils/analytics';

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);